import CustomDropdown from "../../Atoms/DropDowns/CustomDropdown";
import { useSolution } from "../../../contexts/SolutionsContext";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";

const SolVersionDropdown = () => {
  const {
    solutionVersions,
    selectSolVersion,
    currentSolutionVersion,
    isLoadingVersions,
    selectedSolution,
    versionsFetchError,
    setIsLatestVersion
  } = useSolution();

  useEffect(() => {
    if (solutionVersions && solutionVersions.length > 0) {
      const highestVersion = solutionVersions
        .map((v) => v?.version)
        .sort((a, b) => (a > b ? -1 : 1))[0];

      selectSolVersion(highestVersion);
    }
  }, [selectedSolution, solutionVersions]);

  useEffect(() => {
    if (solutionVersions && solutionVersions.length > 0 && currentSolutionVersion) {
      const highestVersion = solutionVersions
        .map((v) => v?.version)
        .sort((a, b) => (a > b ? -1 : 1))[0];

      setIsLatestVersion(currentSolutionVersion === highestVersion);
    }
  }, [currentSolutionVersion, solutionVersions]);

  const versions = solutionVersions?.map((version) => ({
    value: version?.version,
    label: `Release ${version?.version}`,
  }));

  return (
    <>
      <div className="sol-drawer-container">
        <span className="sol-drawer-title">Solution Details</span>
        <div className="wd-14 d-flex" style={{ width: "30%" }}>
          {isLoadingVersions && (
            <div className="d-flex align-items-center justify-content-center me-2">
              <CircularProgress
                style={{ width: "15px", height: "15px", opacity: 0.8 }}
              />
            </div>
          )}
          <CustomDropdown
            selectValues={versions || []}
            handleOnChange={(selectedOption) => {
              selectSolVersion(selectedOption);
            }}
            dropdownLabel={`Release`}
            clsNames={"mas-cust-dd-primary mas-cust-dd-2"}
            disabled={isLoadingVersions || versionsFetchError}
            value={currentSolutionVersion}
          />
        </div>
      </div>
    </>
  );
};

export default SolVersionDropdown;
